module.exports = __webpack_public_path__ + "static/img/banner01.bcf9d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner01.png
// module id = vh2T
// module chunks = 101